var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "charges-table" },
    [
      _c("div", { staticClass: "header-actions mb-4" }, [
        _c(
          "div",
          { staticClass: "flex flex-wrap justify-between items-center gap-4" },
          [
            _c(
              "div",
              { staticClass: "flex items-center gap-3" },
              [
                _vm.countSelected > 0
                  ? _c(
                      "vs-button",
                      {
                        directives: [
                          {
                            name: "can",
                            rawName: "v-can",
                            value: "use_accounting_panel_charges",
                            expression: "'use_accounting_panel_charges'",
                          },
                        ],
                        attrs: {
                          "icon-pack": "feather",
                          icon: "icon-edit",
                          color: "primary",
                        },
                        on: { click: _vm.openPopupChangeState },
                      },
                      [
                        _c("span", { staticClass: "ml-2" }, [
                          _vm._v(
                            "Cambiar estado (" + _vm._s(_vm.countSelected) + ")"
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "vs-button",
                  {
                    attrs: {
                      type: "border",
                      color: "success",
                      icon: _vm.isExporting ? "refresh" : "file_download",
                      disabled: _vm.isExporting,
                    },
                    on: { click: _vm.exportExcel },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.isExporting
                          ? "Exportando..."
                          : "Exportar tabla a Excel"
                      )
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass:
                "flex flex-col items-center justify-center py-16 gap-4",
            },
            [
              _c("div", { staticClass: "spinner" }),
              _c("p", { staticClass: "text-base font-medium text-grey-dark" }, [
                _vm._v("Cargando datos..."),
              ]),
            ]
          )
        : !_vm.isLoading && _vm.rowData.length === 0
        ? _c(
            "div",
            {
              staticClass:
                "flex flex-col items-center justify-center py-20 gap-4 rounded-lg d-theme-dark-bg p-6",
            },
            [
              _c("feather-icon", {
                attrs: {
                  icon: "CreditCardIcon",
                  svgClasses: "w-16 h-16 text-primary opacity-50",
                },
              }),
              _c("p", { staticClass: "text-xl font-bold text-dark" }, [
                _vm._v("Sin registros"),
              ]),
              _c("p", { staticClass: "text-sm text-grey" }, [
                _vm._v("No hay cobros que mostrar"),
              ]),
            ],
            1
          )
        : _c("vx-card", { staticClass: "table-wrapper-card" }, [
            _c("div", { staticClass: "table-scroll-wrapper" }, [
              _c("table", { staticClass: "closure-data-table" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "col-checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectAll,
                            expression: "selectAll",
                          },
                        ],
                        staticClass: "cursor-pointer",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.selectAll)
                            ? _vm._i(_vm.selectAll, null) > -1
                            : _vm.selectAll,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = _vm.selectAll,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectAll = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectAll = $$c
                              }
                            },
                            _vm.toggleSelectAll,
                          ],
                        },
                      }),
                    ]),
                    _c(
                      "th",
                      {
                        staticClass: "col-campaign sortable",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSort("campaign_id")
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "sortable-header" }, [
                          _vm._v("\n              ID Campaña\n              "),
                          _c(
                            "span",
                            { staticClass: "sort-icons" },
                            [
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronUpIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    "campaign_id",
                                    "asc"
                                  ),
                                },
                              }),
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronDownIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    "campaign_id",
                                    "desc"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticClass: "col-id sortable",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSort("closure_number")
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "sortable-header" }, [
                          _vm._v(
                            "\n              Número cierre\n              "
                          ),
                          _c(
                            "span",
                            { staticClass: "sort-icons" },
                            [
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronUpIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    "closure_number",
                                    "asc"
                                  ),
                                },
                              }),
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronDownIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    "closure_number",
                                    "desc"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticClass: "col-campaign-name sortable",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSort("campaign_name")
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "sortable-header" }, [
                          _vm._v(
                            "\n              Nombre Campaña\n              "
                          ),
                          _c(
                            "span",
                            { staticClass: "sort-icons" },
                            [
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronUpIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    "campaign_name",
                                    "asc"
                                  ),
                                },
                              }),
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronDownIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    "campaign_name",
                                    "desc"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticClass: "col-agency sortable",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSort("agency")
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "sortable-header" }, [
                          _vm._v("\n              Agencia\n              "),
                          _c(
                            "span",
                            { staticClass: "sort-icons" },
                            [
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronUpIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    "agency",
                                    "asc"
                                  ),
                                },
                              }),
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronDownIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    "agency",
                                    "desc"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticClass: "col-holding sortable",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSort("holding")
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "sortable-header" }, [
                          _vm._v("\n              Holding\n              "),
                          _c(
                            "span",
                            { staticClass: "sort-icons" },
                            [
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronUpIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    "holding",
                                    "asc"
                                  ),
                                },
                              }),
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronDownIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    "holding",
                                    "desc"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticClass: "col-legal-name sortable",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSort("billing_information")
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "sortable-header" }, [
                          _vm._v(
                            "\n              Razón Social\n              "
                          ),
                          _c(
                            "span",
                            { staticClass: "sort-icons" },
                            [
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronUpIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    "billing_information",
                                    "asc"
                                  ),
                                },
                              }),
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronDownIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    "billing_information",
                                    "desc"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _c("th", { staticClass: "col-comment" }, [
                      _vm._v("Comentario"),
                    ]),
                    _c("th", { staticClass: "col-period" }, [
                      _vm._v("Período"),
                    ]),
                    _c("th", { staticClass: "col-amount" }, [_vm._v("Total")]),
                    _c("th", { staticClass: "col-currency" }, [
                      _vm._v("Moneda"),
                    ]),
                    _c(
                      "th",
                      {
                        staticClass: "col-due-date sortable",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSort(_vm.DUE_DATE_SORT)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "sortable-header" }, [
                          _vm._v("\n              Vencimiento\n              "),
                          _c(
                            "span",
                            { staticClass: "sort-icons" },
                            [
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronUpIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    _vm.DUE_DATE_SORT,
                                    "asc"
                                  ),
                                },
                              }),
                              _c("feather-icon", {
                                attrs: {
                                  icon: "ChevronDownIcon",
                                  svgClasses: _vm.sortChevronClass(
                                    _vm.DUE_DATE_SORT,
                                    "desc"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _c("th", { staticClass: "col-status" }, [_vm._v("Estado")]),
                    _c("th", { staticClass: "col-actions" }, [_vm._v("Ver +")]),
                  ]),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.rowData, function (row, index) {
                    return _c(
                      "tr",
                      {
                        key: index,
                        class: { "row-selected": _vm.isRowSelected(row) },
                      },
                      [
                        _c("td", { staticClass: "col-checkbox" }, [
                          _c("input", {
                            staticClass: "cursor-pointer",
                            attrs: { type: "checkbox" },
                            domProps: { checked: _vm.isRowSelected(row) },
                            on: {
                              change: function ($event) {
                                return _vm.toggleRowSelection(row)
                              },
                            },
                          }),
                        ]),
                        _c(
                          "td",
                          {
                            staticClass: "col-campaign",
                            attrs: { "data-label": "ID Campaña" },
                          },
                          [
                            _c("span", { staticClass: "campaign-name" }, [
                              _vm._v(_vm._s(row.campaign_id || "-")),
                            ]),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "col-id",
                            attrs: { "data-label": "Número cierre" },
                          },
                          [
                            _c("span", { staticClass: "id-badge" }, [
                              _vm._v(_vm._s(row.closure_number)),
                            ]),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "col-campaign-name",
                            attrs: { "data-label": "Nombre Campaña" },
                          },
                          [
                            (row.campaign_name || "").length <= 20
                              ? _c("span", { staticClass: "campaign-name" }, [
                                  _vm._v(_vm._s(row.campaign_name || "-")),
                                ])
                              : _c("span", { staticClass: "campaign-name" }, [
                                  _vm._v(
                                    _vm._s(
                                      (row.campaign_name || "").substring(0, 20)
                                    ) + "..."
                                  ),
                                ]),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "col-agency",
                            attrs: { "data-label": "Agencia" },
                          },
                          [
                            _c("span", { staticClass: "agency-name" }, [
                              _vm._v(_vm._s((row.company || {}).name || "-")),
                            ]),
                            row.responsible_agency
                              ? _c(
                                  "span",
                                  { staticClass: "responsible-agency-name" },
                                  [_vm._v(_vm._s(row.responsible_agency.name))]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "col-holding",
                            attrs: { "data-label": "Holding" },
                          },
                          [
                            _c("span", { staticClass: "holding-name" }, [
                              _vm._v(_vm._s(row.holding || "-")),
                            ]),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "col-legal-name",
                            attrs: { "data-label": "Razón Social" },
                          },
                          [
                            ((row.billing_information || {}).name || "")
                              .length <= 20
                              ? _c("span", { staticClass: "legal-name" }, [
                                  _vm._v(
                                    _vm._s(
                                      (row.billing_information || {}).name ||
                                        "-"
                                    )
                                  ),
                                ])
                              : _c("span", { staticClass: "legal-name" }, [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        (row.billing_information || {}).name ||
                                        ""
                                      ).substring(0, 20)
                                    ) + "..."
                                  ),
                                ]),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "col-comment",
                            attrs: { "data-label": "Comentario" },
                          },
                          [
                            (row.campaign_comment || "").length <= 25
                              ? _c("span", { staticClass: "comment-text" }, [
                                  _vm._v(_vm._s(row.campaign_comment || "-")),
                                ])
                              : _c(
                                  "div",
                                  { staticClass: "comment-preview" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "comment-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              row.campaign_comment || ""
                                            ).substring(0, 25)
                                          ) + "..."
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "vs-button",
                                      {
                                        staticClass: "comment-expand-btn",
                                        attrs: {
                                          size: "small",
                                          type: "border",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openCommentModal(
                                              row.campaign_comment
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                Ver\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "col-period",
                            attrs: { "data-label": "Período" },
                          },
                          [
                            _c("span", { staticClass: "period" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatPeriod(row.date_from, row.date_to)
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "col-amount",
                            attrs: { "data-label": "Total a Cobrar" },
                          },
                          [
                            _c("span", { staticClass: "amount" }, [
                              _vm._v(
                                _vm._s(
                                  row.total_to_collect != null
                                    ? parseFloat(row.total_to_collect).toFixed(
                                        2
                                      )
                                    : row.amount
                                    ? parseFloat(row.amount).toFixed(2)
                                    : "0.00"
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "col-currency",
                            attrs: { "data-label": "Moneda" },
                          },
                          [
                            _c("span", { staticClass: "currency" }, [
                              _vm._v(_vm._s(row.currency || "USD")),
                            ]),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "col-due-date",
                            attrs: { "data-label": "Vencimiento" },
                          },
                          [
                            _c("span", { staticClass: "due-date" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatDate(row.collection_due_date) || "-"
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "col-status",
                            attrs: { "data-label": "Estado" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "status-chip-wrapper",
                                on: {
                                  click: function ($event) {
                                    return _vm.changeStateForRow(row)
                                  },
                                },
                              },
                              [
                                _c(
                                  "vs-chip",
                                  {
                                    staticClass: "status-chip",
                                    attrs: {
                                      color:
                                        row.charge_status === "collected"
                                          ? "#28C76F"
                                          : "#EA5455",
                                      textWhite: "",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.getChargeStatusLabel(row)) +
                                        "\n                "
                                    ),
                                    _c("feather-icon", {
                                      attrs: {
                                        icon: "Edit2Icon",
                                        svgClasses: "w-3 h-3 ml-1 opacity-75",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                (row.charge || {}).cancellation_comment
                                  ? _c("feather-icon", {
                                      attrs: {
                                        icon: "InfoIcon",
                                        svgClasses:
                                          "w-4 h-4 text-danger cursor-pointer flex-shrink-0",
                                        title: "Ver motivo de anulación",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.openCommentModal(
                                            row.charge.cancellation_comment,
                                            "Motivo de anulación"
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          { staticClass: "col-actions" },
                          [
                            _c("vs-button", {
                              attrs: {
                                size: "small",
                                type: "border",
                                color: "primary",
                                "icon-pack": "feather",
                                icon: "icon-plus",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openDetailModal(row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _vm.rowData.length > 0
              ? _c("div", { staticClass: "table-footer" }, [
                  _c("div", { staticClass: "pagination-info" }, [
                    _c("span", { staticClass: "text-grey-dark text-sm" }, [
                      _vm._v(
                        "\n          Mostrando " +
                          _vm._s(_vm.displayRangeStart) +
                          "-" +
                          _vm._s(_vm.displayRangeEnd) +
                          " de " +
                          _vm._s(_vm.effectiveTotal) +
                          " registros\n        "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "pagination-controls" },
                    [
                      _c("vs-button", {
                        attrs: {
                          disabled: _vm.currentPage <= 1,
                          type: "border",
                          "icon-pack": "feather",
                          icon: "icon-chevron-left",
                          size: "small",
                        },
                        on: {
                          click: function ($event) {
                            _vm.currentPage = _vm.currentPage - 1
                          },
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "pagination-numbers" },
                        _vm._l(_vm.pageRange, function (page) {
                          return _c(
                            "vs-button",
                            {
                              key: page,
                              staticClass: "page-button",
                              attrs: {
                                color:
                                  _vm.currentPage === page ? "primary" : "",
                                size: "small",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.currentPage = page
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " + _vm._s(page) + "\n          "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c("vs-button", {
                        attrs: {
                          disabled: _vm.currentPage >= _vm.effectivePages,
                          type: "border",
                          "icon-pack": "feather",
                          icon: "icon-chevron-right",
                          size: "small",
                        },
                        on: {
                          click: function ($event) {
                            _vm.currentPage = _vm.currentPage + 1
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
      _c("charges-details", {
        attrs: { modalActive: _vm.modalActive, modalData: _vm.detailModalData },
        on: {
          "update:modalActive": function ($event) {
            _vm.modalActive = $event
          },
          "update:modal-active": function ($event) {
            _vm.modalActive = $event
          },
        },
      }),
      _c("charges-state-change-popup", {
        attrs: { popupActive: _vm.popupActive, selectedRows: _vm.selectedRows },
        on: {
          "update:popupActive": function ($event) {
            _vm.popupActive = $event
          },
          "update:popup-active": function ($event) {
            _vm.popupActive = $event
          },
          refresh: _vm.getGridData,
        },
      }),
      _c("comment-modal", {
        attrs: {
          modalActive: _vm.commentModalActive,
          comment: _vm.fullCommentText,
          title: _vm.commentModalTitle,
        },
        on: {
          "update:modalActive": function ($event) {
            _vm.commentModalActive = $event
          },
          "update:modal-active": function ($event) {
            _vm.commentModalActive = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }